import type { TextAlertEvent } from '@shared/types'

import { type EffectPlugin } from '@shared/lib/effect-registry'

import { TextAlert } from '../TextAlert'

export const textAlertPlugin: EffectPlugin<TextAlertEvent> = {
  type: 'text_alert',
  component: TextAlert,
  // sound не задан — текстовый алерт без звука по умолчанию
  // Можно добавить: sound: { src: '/sounds/ding.mp3', volume: 0.5 }
}
